import { v4 as uuidv4 } from "uuid";
import { ConditionGroup } from "stores/data/insightAlerts/insightAlertModel";
import { EnvironmentalVariables } from "enum/EnvironmentalVariables";

export const createDefaultConditionGroup = (
  parentId: string | null = null,
  defaultEnvironmentalVariableId: number = 7,
  defaultEnvironmentalVariable: string = EnvironmentalVariables.WIND_VEL,
): ConditionGroup => ({
  id: uuidv4(),
  parentId,
  groupOperator: "and",
  conditionOperator: "and",
  conditions: [
    {
      environmentalVariable: defaultEnvironmentalVariable,
      environmentalVariableId: defaultEnvironmentalVariableId,
      comparisonOperator: ">",
      value: 0,
    },
  ],
});

export const createDefaultCondition = (
  defaultEnvironmentalVariableId: number = 7,
  defaultEnvironmentalVariable: string = EnvironmentalVariables.WIND_VEL,
) => ({
  environmentalVariable: defaultEnvironmentalVariable,
  environmentalVariableId: defaultEnvironmentalVariableId,
  comparisonOperator: ">",
  value: 0,
});

export const reorganizeGroupParentIds = (
  groups: ConditionGroup[],
  removedIndex: number
): ConditionGroup[] => {
  const updatedGroups = [...groups];

  if (removedIndex === 0 && updatedGroups[0]) {
    updatedGroups[0].parentId = null;
  }

  for (let i = removedIndex; i < updatedGroups.length; i++) {
    if (i === 0) {
      updatedGroups[i].parentId = null;
    } else {
      updatedGroups[i].parentId = updatedGroups[i - 1].id;
    }
  }

  return updatedGroups;
};

export const canRemoveGroup = (
  groups: ConditionGroup[],
  groupIndex: number
): boolean => {
  return groups.length > 1 && groupIndex >= 0;
};

export const canRemoveCondition = (
  conditions: any[],
  conditionIndex: number
): boolean => {
  return conditions.length > 1 && conditionIndex >= 0;
};
